// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gothita: PokeData = {
  "id": 574,
  "name": "gothita",
  "height": 4,
  "weight": 58,
  "base_experience": 58,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "feint-attack",
    "charm",
    "psych-up",
    "future-sight",
    "flatter",
    "fake-tears",
    "tickle",
    "embargo",
    "heal-block",
    "psyshock",
    "telekinesis",
    "magic-room",
    "play-nice"
  ],
  "moves": [
    "psychic",
    "future-sight",
    "flatter",
    "psy-ball",
    "psychic-fangs",
    "psy-pulse",
    "psychic-terrain",
    "prismatic-cage",
    "healing-wish",
    "reflect",
    "synchronize",
    "calm-mind",
    "psywave"
  ],
  "evolution_chain": {
    "id": 293,
    "item": null,
    "species": [
      {
        "name": "gothita",
        "order": 575,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gothorita",
        "order": 576,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 574,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gothitelle",
        "order": 577,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 575,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 41,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51.25,
    "speed": 45,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
